import { render } from "./PromotionsListFilters.vue?vue&type=template&id=5878d26c&scoped=true"
import script from "./PromotionsListFilters.vue?vue&type=script&lang=js"
export * from "./PromotionsListFilters.vue?vue&type=script&lang=js"

import "./PromotionsListFilters.vue?vue&type=style&index=0&id=5878d26c&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5878d26c"]])

export default __exports__